export default __webpack_public_path__ + "415055cd49e9b5c7eceeabfccaa66559.png";